

import { NgModule } from '@angular/core';
import { TnxSharedModule } from 'tnx-shared';
import { TableInfoFormComponent } from './tableinfo-form/tableinfo-form.component';
import { TableInfoComponent } from './tableinfo.component';
import { TableInfoRoutes } from './tableinfo.routing';

export function declaration() {
    return [TableInfoComponent, TableInfoFormComponent];
}

@NgModule({
    imports: [
        TnxSharedModule
    ],
    declarations: declaration(),
    exports: declaration()
})
export class TableInfoModule {
}

@NgModule({
    imports: [TableInfoModule, TableInfoRoutes],
    exports: [TableInfoModule]
})
export class TableInfoWithRouteModule {
}
